<template>
    <div class="form-group">
        <label class="label">Rate of Tariff</label>
        <div class="col-12 row p-0">
            <div class="col-6 p-0">
                <app-input 
                    type="text"
                    v-model="percentageDisplay"
                    :required="true"
                    :placeholder="'0.00 %'"
                    :disabled="is_view"
                    @blur="rawInputPercentage = ''" 
                />
            </div>
            <div class="col-6 p-0">
                <app-input 
                    type="text"
                    v-model="displayValue"
                    :placeholder="'Value'"
                    :required="true"
                    @input="updateValue"
                    :disabled="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RateTariff',
    props: {
        value: {
            type: Object,
            default: () => ({
                data: '',
                value: ''
            })
        },
        is_view : {
            type : Boolean, 
            default : false,
        }
    },
    data() {
        return {
            rawInputPercentage: '',
            internalValue: { ...this.value }
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.internalValue = { ...newValue };
            },
            deep: true
        }
    },
    computed: {
        percentageDisplay: {
            get() {
                const val = this.internalValue.data;
                if (val === null || val === undefined || val === '') return this.rawInputPercentage || '';

                // Si el usuario está escribiendo, mostramos el raw tal cual
                if (this.rawInputPercentage !== '') return this.rawInputPercentage;

                // Si no está editando, formateamos con %
                const formatted = new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 5
                }).format(val);

                return `${formatted} %`;
            },
            set(newValue) {
                const cleanValue = String(newValue).replace(/[^0-9.]/g, '');
                this.rawInputPercentage = cleanValue;  // guardamos el string tal cual

                if (cleanValue.endsWith('.')) return;  // esperamos a que termine de escribir

                const numericValue = parseFloat(cleanValue);
                this.internalValue.data = isNaN(numericValue) ? 0 : numericValue;
                this.updateValue();
            }
        },
        displayValue: {
            get() {
                const val = this.internalValue.value;
                if (val === null || val === undefined || val === '') return '$ 0.000';
                
                // Usamos Intl.NumberFormat para manejar millones y decimales
                return new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 3,
                    maximumFractionDigits: 3
                }).format(val);
            },
            set(newValue) {
                let cleanValue = String(newValue).replace(/[^0-9.]/g, '');
                let numericValue = parseFloat(cleanValue);
                this.internalValue.value = isNaN(numericValue) ? 0 : numericValue;
                this.updateValue();
            }
        }
    },
    methods: {
        handleFocus() {
            this.isEditing = true;
        },
        handleBlur() {
            this.isEditing = false;
            this.updateValue(); // Emitimos al salir del campo
        },
        updateValue() {
            this.$emit('input', { ...this.internalValue });
        }
    }
}
</script>

<style scoped>
    .label {
        font-weight: 600;
    }
    /* Quitamos paddings laterales de la fila interna para alinear con el label */
    .row {
        margin-left: 0;
        margin-right: 0;
    }
</style>